import {createContext, useContext, useState} from "react";


export const CreateQuoteContext = createContext({
    projectName:"",
    setProjectName: ()=>null,
});

export const CreateQuoteProvider = ({children}) =>{
    const [projectName,setProjectName] = useState("");

    const value = {projectName,setProjectName}
    return <CreateQuoteContext.Provider value={value}>{children}</CreateQuoteContext.Provider>
}

export const useCreateQuoteContext = () => {
    return useContext(CreateQuoteContext);
};